import styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from '@/icons/index'

const DatePicker = (props) => {

    const MIN_YEAR = 2010;

    const namedDays = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const startingPosition = ['sunday', 'monday', 'tuesday', 'wenesday', 'thursday', 'friday', 'saturday'];

    let {
        selectedMonth,
        selectedDay,
        selectedYear,
        pickDateAction,
        minYear = MIN_YEAR,
        maxYear = new Date().getFullYear(),
    } = { ...props };

    const [daysOfMonth, setDaysOfMonth] = useState(30);
    const [dateState, setDateState] = useState({ day: 1, month: 1, year: 2002 });
    const [startingDay, setStartingDay] = useState(0);
    const [now, setNow] = useState(new Date());
    const [showSelectedDay, setShowSelectedDay] = useState(false);

    useEffect(() => {
        let day = selectedDay;
        let month = selectedMonth - 1;
        let year = selectedYear;

        setNow(new Date());
        updateState(day, month, year);
    }, [])

    function updateState(day, month, year) {
        setDateState(
            {
                day: day,
                month: month,
                year: year
            }
        );

        setStartingDay(new Date(year, month, 1).getDay());
        setDaysOfMonth(new Date(year, month + 1, 0).getDate());
        
        if (year === selectedYear && month + 1 === selectedMonth) {
            setShowSelectedDay(true);
        } else {
            setShowSelectedDay(false);
        }
    }

    function nextMonth() {
        let day = dateState.day;
        let month = dateState.month + 1;
        let year = dateState.year;

        if (month > 11) {
            year = year + 1;
            month = 0

            if (year > maxYear) {
                return;
            }
        }

        updateState(day, month, year);
    }

    function previousMonth() {
        let day = dateState.day;
        let month = dateState.month - 1;
        let year = dateState.year;

        if (month < 0) {
            year = year - 1;
            month = 11

            if (year < minYear) {
                return;
            }
        }

        updateState(day, month, year);
    }

    function pickDate(day) {
        let dayObject = {
            day: day,
            month: dateState.month + 1,
            year: dateState.year
        }

        pickDateAction(dayObject);
    }

    function previousYear() {
        let day = dateState.day;
        let month = dateState.month;
        let year = dateState.year - 1;

        if (year < minYear) {
            return;
        }

        updateState(day, month, year);
    }

    function nextYear() {
        let day = dateState.day;
        let month = dateState.month;
        let year = dateState.year + 1;

        if (year > maxYear) {
            return;
        }

        updateState(day, month, year);
    }

    function getDayLink(i) {
        let highlightDay = '';
        if (showSelectedDay && i === selectedDay -1) {
            highlightDay = 'checkDay';
        }

        if (dateState.year == now.getFullYear()) {
            if (dateState.month < now.getMonth()) {
                return (
                    <li key={'pg-day' + i} className={`${styles[highlightDay]}`}>
                        <a onClick={() => pickDate(i + 1)}>{i + 1}</a>
                    </li>
                )
            }

            if (dateState.month == now.getMonth() && i < now.getDate()) {
                return (
                    <li key={'pg-day' + i} className={`${styles[highlightDay]}`}>
                        <a onClick={() => pickDate(i + 1)}>{i + 1}</a>
                    </li>
                )
            }
        } else {
            if (dateState.year < now.getFullYear()) {
                return (
                    <li key={'pg-day' + i} className={`${styles[highlightDay]}`}>
                        <a onClick={() => pickDate(i + 1)}>{i + 1}</a>
                    </li>
                )
            }
        }

        return <li key={'pg-day' + i} className={`${styles['invalid-day']}`}>{i + 1}</li>
    }

    return (
        <div className={`${styles['pg-datepicker']}`}>
            <div className={`${styles['dp-header']} ${styles['top-rounded']}`}>
                <button onClick={previousYear}>
                    <ArrowLeft className={`${styles['icon']}`}/>
                </button>
                <span>
                    {dateState.year}
                </span>
                <button onClick={nextYear}>
                    <ArrowRight className={`${styles['icon']}`}/>
                </button>
            </div>
            <div className={`${styles['dp-header']}`}>
                <button onClick={previousMonth}>
                    <ArrowLeft className={`${styles['icon']}`}/>
                </button>
                <span>
                    {monthNames[dateState.month]}
                </span>
                <button onClick={nextMonth}>
                    <ArrowRight className={`${styles['icon']}`}/>
                </button>
            </div>
            <div className={`${styles['dp-content']}`}>
                <ol>
                    {namedDays.map((el, index) => {
                        return <li key={'dp-header' + index} className={`${styles['named-days']}`}>{el}</li>;
                    })}
                </ol>
                <ol className={`${styles[startingPosition[startingDay]]} ${styles['days-container']}`}>
                    {Array.from(Array(daysOfMonth), (e, i) => {
                        return getDayLink(i);
                    })}
                </ol>
            </div>
        </div>
    );
}

export default DatePicker;